











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ProgressBar extends Vue {
  @Prop({ type: Number }) maxDuration?: number
  @Prop({ type: Boolean }) isStopCountIncrease?: boolean
  count: number = 0
  countIncreaseTimer: any = null

  countIncrease() {
    this.resetCount()
    this.countIncreaseTimer = setInterval(() => {
      this.count ++
      if (!this.maxDuration) {
        return
      }
      if (this.count >= this.maxDuration || this.isStopCountIncrease) {
        this.resetCount()
      }
    }, 1000)
  }
  resetCount() {
    clearInterval(this.countIncreaseTimer)
    this.countIncreaseTimer = null
  }
  mounted() {
    this.countIncrease()
  }
}
